// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}

.__text-editor {
  --inner-padding-end: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/tickets/modals/ticket-reply/ticket-reply.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;;AAEA;EACI,wBAAA;AACJ","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n}\n\n.__text-editor {\n    --inner-padding-end: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
